<template>
  <div id="introduction">
    <div class="row">
      <div class="col-12 mb-5">
        <div class="card bg-gradient-default shadow">
          <div class="card-header bg-transparent">
            <div class="row align-items-center">
              <div class="col">
                <h2 class="text-white mb-0">Major Accomplishments this Year</h2>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-for="accomplishment in accomplishments" class="grid-item-container">
              <div @click="showAccomplishmentDetail(accomplishment)" class="grid-item clickable">
                <div v-html="accomplishment.icon" class="grid-icon">
                </div><!-- /.grid-icon -->
                <div class="grid-title">
                  {{ accomplishment.title }}
                </div><!-- /.grid-title -->
              </div><!-- /.grid-item -->
            </div><!-- /.grid-item-container -->
          </div>
        </div>
      </div>
    </div>

    <!-- ACCOMPLISHMENT DETAIL MODAL -->
    <transition name="fade">
      <div v-if="showAccomplishmentDetailModal == true" class="grid-modal-container">
        <div class="grid-modal">
          <a @click="closeAccomplishmentModal()" class="close clickable"><i class="far fa-times"></i></a>
          <div v-html="accomplishmentDetailed.icon" class="grid-modal-icon">
          </div><!-- /.grid-modal-icon -->
          <div class="grid-modal-title">
            {{ accomplishmentDetailed.title }}
          </div><!-- /.grid-modal-title -->
          <div class="grid-modal-description">
            {{ accomplishmentDetailed.description }}
          </div><!-- grid-modal-description -->
          <div v-if="accomplishmentDetailed.map" class="modal-map">
            <iframe width="100%" height="450px" :src="accomplishmentDetailed.mapUrl" />
          </div>
        </div><!-- /.grid-modal-container -->
      </div><!-- /.grid-modal-container -->
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accomplishments: [
        {
          icon: '<i class="fas fa-home"></i>',
          title: 'SALES 4 REHAB',
          description: '16 Properties were sold, representing $689,700 in assessment value returned to the county tax rolls, and $734,794 in private reinvestment in our neighborhoods via housing rehabilitation.'
        },
        {
          icon: '<i class="fas fa-exclamation-triangle"></i>',
          title: 'DEMOLITIONs',
          description: 'Demolitions got off to a slow start, hampered by the lack of availability of contractors after a wet spring caused scheduling delays. In spite of the delays, 23 Properties were demolished, representing $501,000 in state funded (non-tax dollars) investment in blight eradication and improved neighborhood health and safety. ',
          map: false,
          mapUrl: 'https://labs.orbitist.com/cclbc-2018-annual-report/maps/demos/#10/42.3142/-79.3705'
        },
        // {
        //   icon: '<i class="fas fa-user-friends"></i>',
        //   title: 'NEIGHBORS 4 NEIGHBORHOODS Program',
        //   description: '4 Properties, 2 in Dunkirk and 2 in Jamestown, renovated to high quality standards, creating 7 affordable rentals that are beautiful, lead and asbestos-free with responsible land lords committed to keeping them up to standard and at affordable rent levels for the next 20 years. This program represents a state (non-tax dollars) investment of over $450,000 in affordable housing in our communities.'
        // },
        {
          icon: '<i class="fas fa-history"></i>',
          title: 'OPERATIONS',
          description: `A significant investment was made in our information management software as we contracted with eProperties Plus,
which provides a secure repository for inventory tracking, management, workflows, and data management. The system
ability to be scaled up will provide opportunities for us to play a critical role as a county-wide data repository and data
analysis provider with regard to real property issues.
As we track our revenues and expenses, we identify opportunities to enhance our sustainability through controlling
costs and improving profits. `
        }
        // {
        //   icon: '<i class="fas fa-laptop-code"></i>',
        //   title: 'New Website',
        //   description: 'Upgraded our web site to provide more program visibility and transparency to our program and policies, and increasing our on line traffic. In 2018 the website served 31,545 pages to 4,423 unique users. 85.6% of those users were new to the site. By far the most visited area of the site was our properties listings with 23.4% of all pageviews hapenning within the properties listings database.'
        // },
        // {
        //   icon: '<i class="fas fa-dollar-sign"></i>',
        //   title: '$2 Million Dollar Grant',
        //   description: 'We secured a $2 million grant from the NYS Attorney General’s office, administered through Enterprise Community Partners, to support our program operations and expansion into 2020.'
        // }
      ],
      showAccomplishmentDetailModal: false,
      accomplishmentDetailed: {}
    }
  },
  methods: {
    closeAccomplishmentModal() {
      this.showAccomplishmentDetailModal = false
    },
    showAccomplishmentDetail(accomplishment) {
      this.accomplishmentDetailed = accomplishment
      this.showAccomplishmentDetailModal = true
    }
  }
}
</script>

<style scoped>
.grid-item-container {
  display: inline-block;
  width: 33%;
  padding: 5px 10px;
}

.grid-item {
  text-align: center;
  background-color: #fff;
  border-radius: 4px;
  padding: 20px 10px 30px;
  transition: all 0.2s ease-in-out;
}

.grid-item:hover {
  transform: scale(1.05);
}

.grid-icon {
  font-size: 50px;
}

.grid-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
  z-index: 1;
  padding: 30px;
  overflow-y: scroll;
}

.grid-modal {
  position: absolute;
  top: 20px;
  width: calc(100% - 60px);
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}

.grid-modal-icon {
  font-size: 50px;
}

.grid-modal-title {
  font-size: 32px;
  font-weight: lighter;
  margin-bottom: 10px;
}

.grid-modal-description {
  margin: 0 auto 20px;
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Work.vue